import { CustomizedRoute } from '../CustimizedRoute/CustomizedRoute';
import { useMultiLayerDrawerContext } from '../MultiLayerDrawerProvider/MultiLayerDrawerProvider';

export const LayerRoute = props => {
    const { registerForm, forms } = useMultiLayerDrawerContext();

    return <CustomizedRoute {...props} registerPage={registerForm} pages={forms} />;
};
